<template>
  <v-dialog v-model="dialog" width="500" @click:outside="cancel" :persistent="isLoading">
    <v-card>
      <v-alert
        v-model="alertVisible"
        type="error"
        density="compact"
        :title="errorMsg"
        :text="$t('common.message.retry')"
        closable
        class="ma-2"
      />

      <v-card-text class="pa-6">
        <p class="text-subtitle-1 mb-10">
          {{ dialogData.message }}
        </p>

        <v-text-field
          ref="staffId"
          density="compact"
          variant="outlined"
          hide-details="auto"
          v-model="staffId"
          :label="$t('shukkaPreDetail.label.staffId')"
          :counter="staffIdLength"
          :maxLength="staffIdLength"
          :disabled="isLoading"
          :rules="[rules.required, rules.halfAlnum]"
        />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn text @click="cancel" :disabled="isLoading">
          {{ $t('common.action.cancel') }}
        </v-btn>
        <v-btn
          color="indigo darken-1"
          dark
          @click="ok"
          :loading="isLoading"
          :disabled="invalidInput"
        >
          {{ $t('common.action.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import constant from "@/utils/constant";

export default {
  props: {
    dialogData: {
      type: Object,
      required: true,
    },
    handleOk: {
      type: Function,
      required: true,
    },
    handleCancel: {
      type: Function,
      required: true,
    },
  },
  computed: {
    invalidInput() {
      if (!this.staffId) return true;
      return !this.isValidStaffId(this.staffId);
    },
  },
  data() {
    return {
      dialog: true,
      isLoading: false,
      alertVisible: false,
      errorMsg: "",
      staffId: "",
      staffIdLength: 0,
      rules: {
        required: v => !!v || this.$t("shukkaPreDetail.validation.required"),
        halfAlnum: v => this.isValidStaffId(v) || this.$t("shukkaPreDetail.validation.halfAlnum"),
      },
    };
  },
  mounted() {
    this.staffIdLength = constant.STAFF_CODE_MAX_LENGTH;
  },
  methods: {
    isValidStaffId(value) {
      return /^[0-9A-Za-z]*$/.test(value ?? "");
    },
    cancel() {
      if (this.isLoading) return;
      this.handleCancel();
    },
    async ok() {
      if (this.invalidInput) return;
      this.isLoading = true;
      this.alertVisible = false;
      this.errorMsg = "";

      try {
        await this.handleOk(this.staffId);
      } catch (error) {
        this.errorMsg = error?.message ?? this.$t("common.message.errorAndRetry");
        this.alertVisible = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
